// ホームのセクション表示順。保有物件・マッチ状況で並びが変わるため、描画から切り離して定義する。
export type HomeSectionKey =
  | "styleDiagnosis"
  | "cashflow"
  | "matchingAgent"
  | "compatibilityAgents"
  | "announcement"
  | "limitedProperties"
  | "premiumWebinar"
  | "learning";

interface HomeSectionOrderParams {
  // 保有物件の読み込みが終わり、かつ物件を保有している
  hasOwnedProperties: boolean;
  // マッチ中の認定プランナーが1人以上いる
  hasProposalMatchings: boolean;
}

// ルールをそのままコードで表現する（パターンごとの全列挙にすると、セクション追加時に
// 全分岐の編集が必要になり、1つ漏れると特定のユーザー状態でだけ表示が崩れるため）。
// - 投資スタイル診断のミニ表示は常に最上部
// - キャッシュフローは物件保有時のみ
// - 相性の良いプランナーは診断ミニ表示の直下。ただしマッチ済みのプランナーがいる場合は
//   「マッチ中の認定プランナー」の直下へ下げる（マッチ済みが上、これから会う候補が下）
// - 末尾は全パターン共通で「お知らせ → 限定物件 → 限定動画 → 学習コンテンツ」
export const buildHomeSectionOrder = ({
  hasOwnedProperties,
  hasProposalMatchings,
}: HomeSectionOrderParams): HomeSectionKey[] => {
  const order: HomeSectionKey[] = ["styleDiagnosis"];
  if (hasOwnedProperties) order.push("cashflow");
  // マッチ中セクション自体は描画側が proposalMatchings の有無で出し分けるため、
  // 並び上は「マッチ済みか物件保有か」いずれかの場合に枠を置く（従来の並びを維持）
  if (hasOwnedProperties || hasProposalMatchings) order.push("matchingAgent");

  const insertIndex = hasProposalMatchings ? order.indexOf("matchingAgent") + 1 : 1;
  order.splice(insertIndex, 0, "compatibilityAgents");

  order.push("announcement", "limitedProperties", "premiumWebinar", "learning");
  return order;
};

// PCは左の概要カラムに収支の空状態も用意する。SPの条件による並びは維持する。
const PC_LEFT_SECTIONS: HomeSectionKey[] = ["styleDiagnosis", "cashflow", "matchingAgent", "announcement"];
export const splitHomeSectionOrderForPc = (
  order: HomeSectionKey[]
): { left: HomeSectionKey[]; right: HomeSectionKey[] } => ({
  left: PC_LEFT_SECTIONS.filter((key) => key === "cashflow" || order.includes(key)),
  right: order.filter((key) => !PC_LEFT_SECTIONS.includes(key)),
});
